import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["primaryMemberSelect"];
  static values = {
    oldPrimaryMemberId: Number,
    oldPrimaryMemberName: String
  };

  confirm(event) {
    if (!this.hasPrimaryMemberSelectTarget) return;

    const selectedId = this.primaryMemberSelectTarget.value;
    if (!selectedId) return;

    const selectedIdNumber = Number(selectedId);
    if (selectedIdNumber === this.oldPrimaryMemberIdValue) return;

    const selectedName = this.selectedPrimaryMemberName();
    const message = [
      `You are about to change the Primary Member from ${this.oldPrimaryMemberNameValue} to ${selectedName}.`,
      "",
      "Do you want to continue?"
    ].join("\n");

    if (!window.confirm(message)) {
      event.preventDefault();
    }
  }

  selectedPrimaryMemberName() {
    const selectedOption = this.primaryMemberSelectTarget.selectedOptions[0];
    return selectedOption ? selectedOption.text.trim() : "selected member";
  }
}
